import OccasionMessageState from './occasion-message-state';
import { reduce } from 'microstates';

export default class OccasionState {
  isSelected = Boolean;
  title = String;
  messages = [OccasionMessageState];

  select() {
    return this.isSelected.set(true);
  }

  deselect() {
    return this.isSelected.set(false).messages.map(m => m.deselect());
  }

  selectMessageFrom(text) {
    return this.messages.map(m => {
      return m.text.state === text
        ? m.select()
        : m.deselect()
    });
  }

  get selected() {
    let t = this;
    const { selected } = reduce(t.messages, (acc, val) => {
      if (acc.selected) {
        return acc;
      }
      return val.isSelected.state
        ? (() => {
          acc.selected = val;
          return acc;
        })()
        : acc;
    }, { selected: null, t });

    return selected;
  }
}
